import React from "react";
import popupStyles from "../../modals/cookies_popup/cookies_popup.module.css";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import doctor from "../../../images/questionnaire_doctor.png";
import i18n from "../../../i18n";

interface IPrivacyPolicyConsentPopupProps {
  handleAccept: () => void;
}
const PrivacyPolicyConsentPopup: React.FC<IPrivacyPolicyConsentPopupProps> = ({
  handleAccept,
}: IPrivacyPolicyConsentPopupProps) => {
  return (
    <article className={popupStyles.popup} data-testid="privacy-policy-consent-popup">
      <h2 className={popupStyles.popup__title}>
        {t("PRIVACY_PROTECTION_DECLARATION")}
      </h2>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY")}
        className={popupStyles.popup__img}
      />
      <p dir={i18n.dir()} className={popupStyles.popup__text}> {t("PRIVACY_COMMITMENT_GTM")} 
        <a
          href="https://bpreven.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          className={popupStyles.popup__privacyLink}
        >
          {t("PRIVACY_POLICY")}
        </a></p>

      <button
        type={"button"}
        className={`button hover ${popupStyles.popup__nextBtn}`}
        data-testid="privacy-policy-consent-popup-button"
        onClick={handleAccept}
      >
        {t("CONTINUE")}
      </button>
    </article>
  );
};

export default PrivacyPolicyConsentPopup;
